import auth from '@/Data/Functions/auth';

const PARENT_SITEMANAGEMENT = 'Site Management',
    PARENT_PRODUCTMANAGEMENT = 'Item Management',
    PARENT_PRODUCTORGANISATION = 'Item Organisation',
    PARENT_REPORTSLISTS = 'Reports & Lists',
    PARENT_MARKETINGPROMOTIONS = 'Marketing & Promotions',
    PARENT_MARKETPLACETOOLS = 'Marketplace Tools',
    PARENT_SUPERUSERS = 'Super Users',
    PARENT_WIZARDS = 'Wizards';

export const ROUTES = [
    {
        path: '/login',
        name: 'Login',
        component: () => import(/* webpackChunkName: "ROUTE___Login" */ '@/pages/Login/Login'),
        meta: {
            securityLevelRequired: [],
            title: 'Login',
            hideFromNav: true
        }
    },
    {
        path: '/',
        name: 'Home',
        component: () => import(/* webpackChunkName: "ROUTE___Home" */ '@/pages/Home/Home'),
        meta: {
            securityLevelRequired: ['Administrator', 'Ecommerce Management', 'Payment Management', 'Payments Administrator'],
            title: 'Dashboard',
            hideFromNav: true,
            isQuicklink: true
        }
    },
    {
        path: '/products/amazon/:uid',
        name: 'AmazonProduct',
        component: () => import(/* webpackChunkName: "ROUTE___AmazonProductEdit" */ '@/pages/ProductManagement/Products/AmazonProductActivation/AmazonProductActivation'),
        meta: {
            securityLevelRequired: ['Administrator', 'Ecommerce Management'],
            title: 'Amazon Item Settings',
            breadcrumbs: [PARENT_PRODUCTMANAGEMENT],
            hideFromNav: true
        }
    },
    {
        path: '/category-manager',
        name: 'CategoryManager',
        component: () => import(/* webpackChunkName: "ROUTE___CategoryManager" */ '@/pages/SiteManagement/CategoryManager/CategoryManager'),
        meta: {
            securityLevelRequired: ['Administrator', 'Ecommerce Management'],
            title: 'Category List',
            breadcrumbs: [PARENT_SITEMANAGEMENT]
        }
    },
    {
        path: '/category-manager/:uid',
        name: 'EditCategory',
        component: () => import(/* webpackChunkName: "ROUTE___EditCategory" */ '@/pages/SiteManagement/CategoryManager/CategoryEdit/CategoryEdit'),
        meta: {
            securityLevelRequired: ['Administrator', 'Ecommerce Management'],
            title: 'Edit Category',
            breadcrumbs: [PARENT_SITEMANAGEMENT],
            hideFromNav: true
        }
    },
    {
        path: '/coupons',
        name: 'Coupons',
        component: () => import(/* webpackChunkName: "ROUTE___Coupons" */ '@/pages/MarketingPromotions/Coupons/Coupons'),
        meta: {
            securityLevelRequired: ['Administrator', 'Ecommerce Management'],
            title: 'Coupons List',
            breadcrumbs: [PARENT_MARKETINGPROMOTIONS, 'Coupons']
        }
    },
    {
        path: '/coupons/new',
        name: 'NewCoupon',
        component: () => import(/* webpackChunkName: "ROUTE___EditCoupon" */ '@/pages/MarketingPromotions/Coupons/EditCoupon/EditCoupon'),
        meta: {
            securityLevelRequired: ['Administrator', 'Ecommerce Management'],
            title: 'New Coupon',
            breadcrumbs: [PARENT_MARKETINGPROMOTIONS],
            hideFromNav: true
        }
    },
    {
        path: '/coupons/:uid',
        name: 'EditCoupons',
        component: () => import(/* webpackChunkName: "ROUTE___EditCoupon" */ '@/pages/MarketingPromotions/Coupons/EditCoupon/EditCoupon'),
        meta: {
            securityLevelRequired: ['Administrator', 'Ecommerce Management'],
            title: 'Coupon Edit',
            breadcrumbs: [PARENT_MARKETINGPROMOTIONS],
            hideFromNav: true
        }
    },
    {
        path: '/coupons-usage',
        name: 'CouponsUsage',
        component: () => import(/* webpackChunkName: "ROUTE___CouponsUsage" */ '@/pages/MarketingPromotions/Coupons/Usage/CouponsUsage'),
        meta: {
            securityLevelRequired: ['Administrator', 'Ecommerce Management'],
            title: 'Coupon Usage Report',
            breadcrumbs: [PARENT_MARKETINGPROMOTIONS, 'Coupons']
        }
    },
    {
        path: '/coupons-settings',
        name: 'CouponSettings',
        component: () => import(/* webpackChunkName: "ROUTE___CouponSettings" */ '@/pages/MarketingPromotions/Coupons/Settings/CouponSettings'),
        meta: {
            securityLevelRequired: ['Administrator', 'Ecommerce Management'],
            title: 'Coupon Settings',
            breadcrumbs: [PARENT_MARKETINGPROMOTIONS, 'Coupons']
        }
    },
    {
        path: '/brands',
        name: 'Brands',
        component: () => import(/* webpackChunkName: "ROUTE___Brands" */ '@/pages/ProductManagement/Brands/Brands'),
        meta: {
            securityLevelRequired: ['Administrator', 'Ecommerce Management'],
            title: 'Brands List',
            breadcrumbs: [PARENT_PRODUCTMANAGEMENT]
        }
    },
    {
        path: '/brands/brandlink',
        name: 'BrandLink',
        component: () => import(/* webpackChunkName: "ROUTE___BrandLink" */ '@/pages/ProductManagement/Brands/BrandLink/BrandLink'),
        meta: {
            securityLevelRequired: ['Administrator', 'Ecommerce Management'],
            title: 'Brand Link List',
            breadcrumbs: [PARENT_PRODUCTMANAGEMENT],
            hideFromNav: true
        }
    },
    {
        path: '/brands/:uid',
        name: 'EditBrand',
        component: () => import(/* webpackChunkName: "ROUTE___EditBrand" */ '@/pages/ProductManagement/Brands/EditBrand/EditBrand'),
        meta: {
            securityLevelRequired: ['Administrator', 'Ecommerce Management'],
            title: 'Brand Edit',
            breadcrumbs: [PARENT_PRODUCTMANAGEMENT],
            hideFromNav: true
        }
    },
    {
        path: '/ebay-import-categories',
        name: 'eBay Import Categories',
        component: () => import(/* webpackChunkName: "ROUTE___EBayImportCategories" */ '@/pages/MarketPlaceTools/EbayImportCategories/EbayImportCategories'),
        meta: {
            securityLevelRequired: ['Administrator', 'Ecommerce Management'],
            title: 'eBay Import Categories',
            breadcrumbs: [PARENT_MARKETPLACETOOLS, 'eBay']
        }
    },
    {
        path: '/ebay-management',
        name: 'eBayManagement',
        component: () => import(/* webpackChunkName: "ROUTE___EBayManagement" */ '@/pages/MarketPlaceTools/EBayManagement/EBayManagement'),
        meta: {
            securityLevelRequired: ['Administrator', 'Ecommerce Management'],
            title: 'eBay Management',
            breadcrumbs: [PARENT_MARKETPLACETOOLS, 'eBay']
        }
    },
    {
        path: '/filters',
        name: 'Filters',
        component: () => import(/* webpackChunkName: "ROUTE___Filters" */ '@/pages/ProductOrganisation/Filters/Filters'),
        meta: {
            securityLevelRequired: ['Administrator', 'Ecommerce Management'],
            title: 'Find & Filter Set-up',
            breadcrumbs: [PARENT_PRODUCTORGANISATION, 'Find & Filter']
        }
    },
    {
        path: '/item-filter-quick-apply',
        name: 'ItemFilterQuickApply',
        component: () => import(/* webpackChunkName: "ROUTE___ItemFilterQuickApply" */ '@/pages/ProductOrganisation/ItemFilterQuickApply/ItemFilterQuickApply'),
        meta: {
            securityLevelRequired: ['Administrator', 'Ecommerce Management'],
            title: 'Item Filter Quick Apply',
            breadcrumbs: [PARENT_PRODUCTORGANISATION, 'Find & Filter']
        }
    },
    {
        path: '/filter-collections',
        name: 'FilterCollections',
        component: () => import(/* webpackChunkName: "ROUTE___FilterCollections" */ '@/pages/ProductOrganisation/FilterCollections/FilterCollections'),
        meta: {
            securityLevelRequired: ['Administrator', 'Ecommerce Management'],
            title: 'Find & Filter Collections',
            breadcrumbs: [PARENT_PRODUCTORGANISATION]
        }
    },
    {
        path: '/filter-collections/new',
        name: 'NewFilterCollection',
        component: () => import(/* webpackChunkName: "ROUTE___NewFilterCollection" */ '@/pages/ProductOrganisation/FilterCollections/FilterCollectionEdit/FilterCollectionEdit'),
        meta: {
            securityLevelRequired: ['Administrator', 'Ecommerce Management'],
            title: 'New Find & Filter Collection',
            breadcrumbs: [PARENT_PRODUCTORGANISATION],
            hideFromNav: true
        }
    },
    {
        path: '/filter-collections/:uid',
        name: 'FilterCollectionEdit',
        component: () => import(/* webpackChunkName: "ROUTE___FilterCollectionEdit" */ '@/pages/ProductOrganisation/FilterCollections/FilterCollectionEdit/FilterCollectionEdit'),
        meta: {
            securityLevelRequired: ['Administrator', 'Ecommerce Management'],
            title: 'Find & Filter Collection Edit',
            breadcrumbs: [PARENT_PRODUCTORGANISATION],
            hideFromNav: true
        }
    },
    {
        path: '/filter-alp-management',
        name: 'AutomaticLandingPageManager',
        component: () => import(/* webpackChunkName: "ROUTE___AutomaticLandingPageManager" */ '@/pages/ProductOrganisation/AutomaticLandingPageManager/AutomaticLandingPageManager'),
        meta: {
            securityLevelRequired: ['Administrator', 'Ecommerce Management'],
            title: 'Find & Filter Landing Pages',
            breadcrumbs: [PARENT_PRODUCTORGANISATION, 'Find & Filter Settings'],
            hideFromNav: false
        }
    },
    {
        path: '/filter-settings',
        name: 'FAFSettings',
        component: () => import(/* webpackChunkName: "ROUTE___FAFSettings" */ '@/pages/ProductOrganisation/FAFSettings/FAFSettings'),
        meta: {
            securityLevelRequired: ['Administrator', 'Ecommerce Management'],
            title: 'Find & Filter General Settings',
            breadcrumbs: [PARENT_PRODUCTORGANISATION, 'Find & Filter Settings'],
            hideFromNav: false
        }
    },
    {
        path: '/banners',
        name: 'Banners',
        component: () => import(/* webpackChunkName: "ROUTE___Banners" */ '@/pages/SiteManagement/Banners/Banners'),
        meta: {
            securityLevelRequired: ['Administrator', 'Ecommerce Management'],
            title: 'Banner Management',
            breadcrumbs: [PARENT_SITEMANAGEMENT],
            isQuicklink: true
        }
    },
    {
        path: '/banners/new',
        name: 'NewBanners',
        component: () => import(/* webpackChunkName: "ROUTE___NewBanner" */ '@/pages/SiteManagement/Banners/BannerEdit/BannerEdit'),
        meta: {
            securityLevelRequired: ['Administrator', 'Ecommerce Management'],
            title: 'New Banner',
            breadcrumbs: [PARENT_SITEMANAGEMENT],
            hideFromNav: true
        }
    },
    {
        path: '/banners/:uid',
        name: 'BannersEdit',
        component: () => import(/* webpackChunkName: "ROUTE___BannerEdit" */ '@/pages/SiteManagement/Banners/BannerEdit/BannerEdit'),
        meta: {
            securityLevelRequired: ['Administrator', 'Ecommerce Management'],
            title: 'Banner Edit',
            breadcrumbs: [PARENT_SITEMANAGEMENT],
            hideFromNav: true
        }
    },
    {
        path: '/css-fragments',
        name: 'CSSFragments',
        component: () => import(/* webpackChunkName: "ROUTE___CSSFragments" */ '@/pages/SiteManagement/CSSContent/CSSContent'),
        meta: {
            securityLevelRequired: ['Administrator'],
            superUsersOnly: true,
            title: 'CSS Fragments',
            breadcrumbs: [PARENT_SUPERUSERS]
        }
    },
    {
        path: '/css-fragments/new',
        name: 'NewCSSFragment',
        component: () => import(/* webpackChunkName: "ROUTE___NewCSSFragment" */ '@/pages/SiteManagement/CSSContent/CSSContentEdit/CSSContentEdit'),
        meta: {
            securityLevelRequired: ['Administrator'],
            superUsersOnly: true,
            title: 'New CSS Fragment',
            breadcrumbs: [PARENT_SUPERUSERS],
            hideFromNav: true
        }
    },
    {
        path: '/css-fragments/:uid',
        name: 'CSSFragmentsEdit',
        component: () => import(/* webpackChunkName: "ROUTE___CSSFragmentsEdit" */ '@/pages/SiteManagement/CSSContent/CSSContentEdit/CSSContentEdit'),
        meta: {
            securityLevelRequired: ['Administrator'],
            superUsersOnly: true,
            title: 'Edit CSS Fragments',
            breadcrumbs: [PARENT_SUPERUSERS],
            hideFromNav: true
        }
    },
    {
        path: '/click-and-collect',
        name: 'ClickAndCollect',
        component: () => import(/* webpackChunkName: "ROUTE___ClickAndCollect" */ '@/pages/SiteManagement/ClickAndCollect/ClickAndCollect'),
        meta: {
            securityLevelRequired: ['Administrator', 'Ecommerce Management'],
            title: 'Click & Collect Stores',
            breadcrumbs: [PARENT_SITEMANAGEMENT]
        }
    },
    {
        path: '/click-and-collect/:uid',
        name: 'ClickAndCollectEdit',
        component: () => import(/* webpackChunkName: "ROUTE___ClickAndCollectEdit" */ '@/pages/SiteManagement/ClickAndCollect/EditClickAndCollect/EditClickAndCollect'),
        meta: {
            securityLevelRequired: ['Administrator', 'Ecommerce Management'],
            title: 'Edit Click & Collect Store',
            breadcrumbs: [PARENT_SITEMANAGEMENT],
            hideFromNav: true
        }
    },
    {
        path: '/click-and-collect/new',
        name: 'NewClickAndCollect',
        component: () => import(/* webpackChunkName: "ROUTE___ClickAndCollectEdit" */ '@/pages/SiteManagement/ClickAndCollect/EditClickAndCollect/EditClickAndCollect'),
        meta: {
            securityLevelRequired: ['Administrator', 'Ecommerce Management'],
            requiresB2C: true,
            title: 'New Click & Collect Store',
            breadcrumbs: [PARENT_SITEMANAGEMENT],
            hideFromNav: true
        }
    },
    {
        path: '/facet-navigation',
        name: 'FacetNavigation',
        component: () => import(/* webpackChunkName: "ROUTE___FacetNavigation" */ '@/pages/SiteManagement/FacetNavigation/FacetNavigation'),
        meta: {
            securityLevelRequired: ['Administrator', 'Ecommerce Management'],
            title: 'Facet Navigation',
            breadcrumbs: [PARENT_SITEMANAGEMENT, 'Find & Filter'],
            isQuicklink: true
        }
    },
    {
        path: '/facet-navigation/seo',
        name: 'FacetNavigationSEOMode',
        component: () => import(/* webpackChunkName: "ROUTE___FacetNavigationSEOMode" */ '@/pages/SiteManagement/FacetNavigation/FacetNavigation'),
        meta: {
            securityLevelRequired: ['Administrator', 'Ecommerce Management'],
            title: 'Advanced Filter SEO',
            breadcrumbs: [PARENT_SITEMANAGEMENT]
        }
    },
    {
        path: '/faqs',
        name: 'FAQs',
        component: () => import(/* webpackChunkName: "ROUTE___FAQManagement" */ '@/pages/SiteManagement/FAQManagement/FAQManagement'),
        meta: {
            securityLevelRequired: ['Administrator', 'Ecommerce Management'],
            title: 'Frequently Asked Questions',
            breadcrumbs: [PARENT_SITEMANAGEMENT]
        }
    },
    {
        path: '/faqs/:uid',
        name: 'FAQEdit',
        component: () => import(/* webpackChunkName: "ROUTE___FaqEdit" */ '@/pages/SiteManagement/FAQManagement/FaqEdit/FaqEdit'),
        meta: {
            securityLevelRequired: ['Administrator', 'Ecommerce Management'],
            title: 'Frequently Asked Questions Edit',
            breadcrumbs: [PARENT_SITEMANAGEMENT],
            hideFromNav: true
        }
    },
    {
        path: '/finance-products',
        name: 'FinanceProducts',
        component: () => import(/* webpackChunkName: "ROUTE___FinanceProducts" */ '@/pages/SiteManagement/FinanceProducts/FinanceProducts'),
        meta: {
            securityLevelRequired: ['Administrator', 'Ecommerce Management'],
            title: 'Finance Products',
            breadcrumbs: [PARENT_SITEMANAGEMENT]
        }
    },
    {
        path: '/general',
        name: 'GeneralFields',
        component: () => import(/* webpackChunkName: "ROUTE___GeneralFieldsAndInfo" */ '@/pages/SiteManagement/GeneralFieldsAndInfo/GeneralFieldsAndInfo'),
        meta: {
            securityLevelRequired: ['Administrator', 'Ecommerce Management'],
            title: 'General Fields',
            breadcrumbs: [PARENT_SITEMANAGEMENT]
        }
    },
    {
        path: '/general-pages',
        name: 'GeneralPages',
        component: () => import(/* webpackChunkName: "ROUTE___GeneralPages" */ '@/pages/SiteManagement/GeneralPages/GeneralPages'),
        meta: {
            securityLevelRequired: ['Administrator', 'Ecommerce Management'],
            title: 'General Pages',
            breadcrumbs: [PARENT_SITEMANAGEMENT]
        }
    },
    {
        path: '/incorrect-primary-categories',
        name: 'Incorrect Primary Categories',
        component: () => import(/* webpackChunkName: "ROUTE___InvalidEBayCategories" */ '@/pages/ReportsAndLists/IncorrectPrimaryCategoriesReport/IncorrectPrimaryCategoriesReport'),
        meta: {
            securityLevelRequired: ['Administrator', 'Ecommerce Management'],
            title: 'Incorrect Primary Categories',
            breadcrumbs: [PARENT_REPORTSLISTS]
        }
    },
    {
        path: '/invalid-ebay-categories',
        name: 'InvalidEbayCategories',
        component: () => import(/* webpackChunkName: "ROUTE___InvalidEbayCategories" */ '@/pages/MarketPlaceTools/InvalidEbayCategories/InvalidEbayCategories'),
        meta: {
            securityLevelRequired: ['Administrator', 'Ecommerce Management'],
            title: 'Invalid eBay Categories Report',
            breadcrumbs: [PARENT_MARKETPLACETOOLS]
        }
    },
    {
        path: '/mailqueue-report',
        name: 'MailQueueReport',
        component: () => import(/* webpackChunkName: "ROUTE___MailQueueReport" */ '@/pages/ReportsAndLists/MailQueue/MailQueue'),
        meta: {
            securityLevelRequired: ['Administrator', 'Ecommerce Management'],
            title: 'Mail Queue Report',
            breadcrumbs: [PARENT_REPORTSLISTS]
        }
    },
    {
        path: '/courier-integration',
        name: 'courierIntegration',
        component: () => import(/* webpackChunkName: "ROUTE___CourierIntegration" */ '@/pages/SuperUsers/CourierIntegration/CourierIntegration'),
        meta: {
            securityLevelRequired: ['Administrator'],
            superUsersOnly: true,
            title: 'Courier Integration',
            breadcrumbs: [PARENT_SUPERUSERS]
        }
    },
    {
        path: '/clonly',
        name: 'CLOnly',
        component: () => import(/* webpackChunkName: "ROUTE___CLOnly" */ '@/pages/SuperUsers/CLOnly/CLOnly'),
        meta: {
            securityLevelRequired: ['Administrator'],
            superUsersOnly: true,
            title: 'Citrus-Lime Only',
            breadcrumbs: [PARENT_SUPERUSERS]
        }
    },
    {
        path: '/select-country',
        name: 'SelectCountry',
        component: () => import(/* webpackChunkName: "ROUTE___SelectCountry" */ '@/pages/SiteManagement/SelectCountry/SelectCountry'),
        meta: {
            securityLevelRequired: ['Administrator', 'Ecommerce Management'],
            title: 'Active Countries',
            breadcrumbs: [PARENT_SITEMANAGEMENT]
        }
    },
    {
        path: '/store-configuration',
        name: 'StoreConfiguration',
        component: () => import(/* webpackChunkName: "ROUTE___StoreConfiguration" */ '@/pages/SiteManagement/StoreConfiguration/StoreConfiguration'),
        meta: {
            securityLevelRequired: ['Administrator', 'Ecommerce Management'],
            title: 'Store Configuration',
            breadcrumbs: [PARENT_SITEMANAGEMENT]
        }
    },
    {
        path: '/site-specific-options',
        name: 'SiteSpecificOptions',
        component: () => import(/* webpackChunkName: "ROUTE___SiteSpecificOptions" */ '@/pages/SiteManagement/SiteSpecificOptions/SiteSpecificOptions'),
        meta: {
            securityLevelRequired: ['Administrator', 'Ecommerce Management'],
            title: 'Site Specific Options',
            breadcrumbs: [PARENT_SITEMANAGEMENT]
        }
    },
    {
        path: '/sim-settings',
        name: 'SimSettings',
        component: () => import(/* webpackChunkName: "ROUTE___SIMSettings" */ '@/pages/SiteManagement/SIMSettings/SIMSettings'),
        meta: {
            securityLevelRequired: ['Administrator', 'Ecommerce Management'],
            title: 'SIM Settings',
            breadcrumbs: [PARENT_SITEMANAGEMENT]
        }
    },
    {
        path: '/websim-stock-edit/:id',
        name: 'WebSimStockEdit',
        component: () => import(/* webpackChunkName: "ROUTE___WebSimStockEdit" */ '@/pages/SiteManagement/SIMSettings/WebSimStockEdit/WebSimStockEdit'),
        props: true,
        meta: {
            securityLevelRequired: ['Administrator', 'Ecommerce Management'],
            title: 'SIM Stock Edit Lead Time',
            breadcrumbs: [PARENT_SITEMANAGEMENT,'SimSettings'],
            hideFromNav: true
        }
    },
    {
        path: '/sim-stock-blocker',
        name: 'SuppressSimStock',
        component: () => import(/* webpackChunkName: "ROUTE___SuppressSimStock" */ '@/pages/ProductManagement/SuppressSimStock/SuppressSimStock'),
        meta: {
            securityLevelRequired: ['Administrator', 'Ecommerce Management'],
            title: 'Block SIM Stock',
            breadcrumbs: [PARENT_PRODUCTMANAGEMENT]
        }
    },
    {
        path: '/buyers-guides',
        name: 'BuyersGuides',
        component: () => import(/* webpackChunkName: "ROUTE___BuyersGuide" */ '@/pages/ProductManagement/BuyersGuide/BuyersGuide'),
        meta: {
            securityLevelRequired: ['Administrator', 'Ecommerce Management'],
            title: 'Buyers Guides',
            breadcrumbs: [PARENT_PRODUCTMANAGEMENT]
        }
    },
    {
        path: '/buyers-guides/new',
        name: 'NewBuyersGuide',
        component: () => import(/* webpackChunkName: "ROUTE___EditBuyersGuide" */ '@/pages/ProductManagement/BuyersGuide/EditBuyersGuide/EditBuyersGuide'),
        meta: {
            securityLevelRequired: ['Administrator', 'Ecommerce Management'],
            title: 'New Buyers Guide',
            breadcrumbs: [PARENT_PRODUCTMANAGEMENT],
            hideFromNav: true
        }
    },
    {
        path: '/buyers-guides/:uid',
        name: 'EditBuyersGuides',
        component: () => import(/* webpackChunkName: "ROUTE___EditBuyersGuide" */ '@/pages/ProductManagement/BuyersGuide/EditBuyersGuide/EditBuyersGuide'),
        meta: {
            securityLevelRequired: ['Administrator', 'Ecommerce Management'],
            title: 'Buyers Guide Edit',
            breadcrumbs: [PARENT_PRODUCTMANAGEMENT],
            hideFromNav: true
        }
    },
    {
        path: '/google-categories',
        name: 'GoogleCategories',
        component: () => import(/* webpackChunkName: "ROUTE___GoogleCategories" */ '@/pages/ProductManagement/GoogleCategories/GoogleCategories'),
        meta: {
            securityLevelRequired: ['Administrator', 'Ecommerce Management'],
            title: 'Google Categories',
            breadcrumbs: [PARENT_PRODUCTMANAGEMENT]
        }
    },
    {
        path: '/custom-builder-templates',
        name: 'CustomBuilderTemplates',
        component: () => import(/* webpackChunkName: "ROUTE___CustomBuilderTemplates" */ '@/pages/ProductManagement/CustomBuilderTemplates/CustomBuilderTemplates'),
        meta: {
            securityLevelRequired: ['Administrator', 'Ecommerce Management'],
            title: 'Custom Builder Templates',
            breadcrumbs: [PARENT_PRODUCTMANAGEMENT],
            isQuicklink: false
        }
    },
    {
        path: '/custom-builder-templates/:uid',
        name: 'EditCustomBuilderTemplates',
        component: () => import(/* webpackChunkName: "ROUTE___EditCustomBuilderTemplates" */ '@/pages/ProductManagement/CustomBuilderTemplates/EditCustomBuilderTemplates/EditCustomBuilderTemplates'),
        meta: {
            securityLevelRequired: ['Administrator', 'Ecommerce Management'],
            title: 'Edit Custom Builder Template',
            breadcrumbs: [PARENT_PRODUCTMANAGEMENT],
            hideFromNav: true
        }
    },
    {
        path: '/products',
        name: 'ProductSearch',
        component: () => import(/* webpackChunkName: "ROUTE___Products" */ '@/pages/ProductManagement/Products/Products'),
        meta: {
            securityLevelRequired: ['Administrator', 'Ecommerce Management'],
            title: 'Item Search',
            breadcrumbs: [PARENT_PRODUCTMANAGEMENT],
            isQuicklink: true
        }
    },
    {
        path: '/products/:uid',
        name: 'ProductEdit',
        component: () => import(/* webpackChunkName: "ROUTE___ProductEdit" */ '@/pages/ProductManagement/Products/ProductEdit/ProductEdit'),
        meta: {
            securityLevelRequired: ['Administrator', 'Ecommerce Management'],
            title: 'Item Edit',
            breadcrumbs: [PARENT_PRODUCTMANAGEMENT],
            hideFromNav: true
        }
    },
    {
        path: '/inactive-products/',
        name: 'InactiveProducts',
        component: () => import(/* webpackChunkName: "ROUTE___InactiveProductsReport" */ '@/pages/ReportsAndLists/InactiveProductsReport/InactiveProductsReport'),
        meta: {
            securityLevelRequired: ['Administrator', 'Ecommerce Management'],
            title: 'Inactive Items List',
            breadcrumbs: [PARENT_REPORTSLISTS, 'Stock Levels']
        }
    },
    {
        path: '/inactive-products/current-season',
        name: 'InactiveProductsForCurrentSeason',
        component: () => import(/* webpackChunkName: "ROUTE___InactiveProductsReport" */ '@/pages/ReportsAndLists/InactiveProductsReport/InactiveProductsReport'),
        meta: {
            securityLevelRequired: ['Administrator', 'Ecommerce Management'],
            title: 'Inactive Items List for Current Season',
            breadcrumbs: [PARENT_REPORTSLISTS],
            hideFromNav: true
        }
    },
    {
        path: '/inactive-styles',
        name: 'InactiveStyles',
        component: () => import(/* webpackChunkName: "ROUTE___InactiveStylesReport" */ '@/pages/ReportsAndLists/InactiveStylesReport/InactiveStylesReport'),
        meta: {
            securityLevelRequired: ['Administrator', 'Ecommerce Management'],
            title: 'Inactive Styles List',
            breadcrumbs: [PARENT_REPORTSLISTS]
        }
    },
    {
        path: '/orders/lines',
        name: 'OrderLines',
        component: () => import(/* webpackChunkName: "ROUTE___OrderLines" */ '@/pages/ReportsAndLists/OrderLines/OrderLines'),
        meta: {
            securityLevelRequired: ['Administrator', 'Ecommerce Management'],
            title: 'Order Lines Report',
            breadcrumbs: [PARENT_REPORTSLISTS]
        }
    },
    {
        path: '/orders/lines/starbuys',
        name: 'OrderLinesStarbuys',
        component: () => import(/* webpackChunkName: "ROUTE___OrderLines" */ '@/pages/ReportsAndLists/OrderLines/OrderLines'),
        meta: {
            securityLevelRequired: ['Administrator', 'Ecommerce Management'],
            title: 'Star Buys Order Report',
            breadcrumbs: [PARENT_REPORTSLISTS]
        }
    },
    {
        path: '/out-of-stock-but-active',
        name: 'OutOfStockButActive',
        component: () => import(/* webpackChunkName: "ROUTE___OutOfStockButActive" */ '@/pages/ReportsAndLists/OutOfStockButActive/OutOfStockButActive'),
        meta: {
            securityLevelRequired: ['Administrator', 'Ecommerce Management'],
            title: 'Out Of Stock But Active Report',
            breadcrumbs: [PARENT_REPORTSLISTS]
        }
    },
    {
        path: '/orders',
        name: 'OrderDashboard',
        component: () => import(/* webpackChunkName: "ROUTE___OrderDashboard" */ '@/pages/ReportsAndLists/Orders/Orders'),
        meta: {
            securityLevelRequired: ['Administrator', 'Ecommerce Management'],
            title: 'Order Dashboard',
            breadcrumbs: [PARENT_REPORTSLISTS]
        }
    },
    {
        path: '/orders/summary',
        name: 'OrderSummary',
        component: () => import(/* webpackChunkName: "ROUTE___OrderSummary" */ '@/pages/ReportsAndLists/OrderSummary/OrderSummary'),
        meta: {
            securityLevelRequired: ['Administrator', 'Ecommerce Management'],
            title: 'Order Summary Report',
            breadcrumbs: [PARENT_REPORTSLISTS]
        }
    },
    {
        path: '/payment-methods',
        name: 'PaymentMethods',
        component: () => import(/* webpackChunkName: "ROUTE___PaymentMethods" */ '@/pages/SuperUsers/PaymentMethods/PaymentMethods'),
        meta: {
            securityLevelRequired: ['Administrator'],
            superUsersOnly: true,
            title: 'Payment Methods',
            breadcrumbs: [PARENT_SUPERUSERS]
        }
    },
    {
        path: '/reviews',
        name: 'Review',
        component: () => import(/* webpackChunkName: "ROUTE___Reviews" */ '@/pages/SiteManagement/Reviews/Reviews'),
        meta: {
            securityLevelRequired: ['Administrator', 'Ecommerce Management'],
            title: 'Customer Reviews',
            breadcrumbs: [PARENT_SITEMANAGEMENT]
        }
    },
    {
        path: '/reviews/:uid',
        name: 'EditReview',
        component: () => import(/* webpackChunkName: "ROUTE___ReviewsEdit" */ '@/pages/SiteManagement/Reviews/EditReview/EditReview'),
        meta: {
            securityLevelRequired: ['Administrator', 'Ecommerce Management'],
            title: 'Review Edit',
            breadcrumbs: [PARENT_SITEMANAGEMENT],
            hideFromNav: true
        }
    },
    {
        path: '/customers',
        name: 'CustomerList',
        component: () => import(/* webpackChunkName: "ROUTE___CustomerList" */ '@/pages/SiteManagement/CustomerList/CustomerList'),
        meta: {
            securityLevelRequired: ['Administrator', 'Ecommerce Management'],
            title: 'Customers',
            breadcrumbs: [PARENT_SITEMANAGEMENT]
        }
    },
    {
        path: '/stock-locations',
        name: 'StockLocations',
        component: () => import(/* webpackChunkName: "ROUTE___StockLocations" */ '@/pages/ReportsAndLists/StockLocations/StockLocations'),
        meta: {
            securityLevelRequired: ['Administrator', 'Ecommerce Management'],
            title: 'Stock Locations Report',
            breadcrumbs: [PARENT_REPORTSLISTS, 'Stock Levels']
        }
    },
    {
        path: '/google-analytics-order-posting',
        name: 'GoogleAnalyticsOrderPosting',
        component: () => import(/* webpackChunkName: "ROUTE___GoogleAnalyticsOrderPosting" */ '@/pages/ReportsAndLists/GoogleAnalyticsOrderPosting/GoogleAnalyticsOrderPosting'),
        meta: {
            securityLevelRequired: ['Administrator', 'Ecommerce Management'],
            title: 'Google Analytics Order Posting Log',
            breadcrumbs: [PARENT_REPORTSLISTS]
        }
    },
    {
        path: '/amazon-planner',
        name: 'AmazonPlanner',
        component: () => import(/* webpackChunkName: "ROUTE___AmazonPlanner" */ '@/pages/MarketPlaceTools/AmazonPlanner/AmazonPlanner'),
        meta: {
            securityLevelRequired: ['Administrator', 'Ecommerce Management'],
            title: 'Amazon Planner',
            breadcrumbs: [PARENT_MARKETPLACETOOLS, 'Amazon']
        }
    },
    {
        path: '/dpd-pickup-usage',
        name: 'DPDPickupUsage',
        component: () => import(/* webpackChunkName: "ROUTE___DPDPickupUsage" */ '@/pages/ReportsAndLists/DPDPickupUsage/DPDPickupUsage'),
        meta: {
            securityLevelRequired: ['Administrator', 'Ecommerce Management'],
            title: 'DPD Pickup Usage Report',
            breadcrumbs: [PARENT_REPORTSLISTS]
        }
    },
    {
        path: '/click-and-collect-orders',
        name: 'ClickAndCollectOrders',
        component: () => import(/* webpackChunkName: "ROUTE___ClickAndCollectOrders" */ '@/pages/ReportsAndLists/ClickAndCollectOrders/ClickAndCollectOrders'),
        meta: {
            securityLevelRequired: ['Administrator', 'Ecommerce Management'],
            title: 'Click & Collect Orders',
            breadcrumbs: [PARENT_REPORTSLISTS]
        }
    },
    {
        path: '/filter-custom-repeaters',
        name: 'FilterCustomRepeaters',
        component: () => import(/* webpackChunkName: "ROUTE___FilterCustomRepeaters" */ '@/pages/ProductOrganisation/FilterCustomRepeaters/FilterCustomRepeaters'),
        meta: {
            securityLevelRequired: ['Administrator', 'Ecommerce Management'],
            title: 'Find & Filter Custom Repeaters',
            breadcrumbs: [PARENT_PRODUCTORGANISATION],
            isQuicklink: true
        }
    },
    {
        path: '/filter-custom-repeaters/:uid',
        name: 'FilterCustomRepeatersEdit',
        component: () => import(/* webpackChunkName: "ROUTE___FilterCustomRepeatersEdit" */ '@/pages/ProductOrganisation/FilterCustomRepeaters/FilterCustomRepeatersEdit/FilterCustomRepeatersEdit'),
        meta: {
            securityLevelRequired: ['Administrator', 'Ecommerce Management'],
            title: 'Find & Filter Custom Repeaters Edit',
            breadcrumbs: [PARENT_PRODUCTORGANISATION],
            hideFromNav: true
        }
    },
    {
        path: '/click-and-collect/:uid',
        name: 'EditClickAndCollect',
        component: () => import(/* webpackChunkName: "ROUTE___EditClickAndCollect" */ '@/pages/SiteManagement/ClickAndCollect/EditClickAndCollect/EditClickAndCollect'),
        meta: {
            securityLevelRequired: ['Administrator', 'Ecommerce Management'],
            title: 'Edit Click & Collect Store',
            breadcrumbs: [PARENT_SITEMANAGEMENT],
            hideFromNav: true
        }
    },
    {
        path: '/cyclescheme-restricted-facets',
        name: 'CycleschemeRestrictedFacetList',
        component: () => import(/* webpackChunkName: "ROUTE___CycleschemeRestrictedFacetList" */ '@/pages/SiteManagement/CycleschemeRestrictedFacetList/CycleschemeRestrictedFacetList'),
        meta: {
            securityLevelRequired: ['Administrator'],
            title: 'Cyclescheme Restricted Facets List',
            breadcrumbs: [PARENT_SITEMANAGEMENT]
        }
    },
    {
        path: '/ebay-planner-filterable',
        name: 'eBayPlannerfilterable',
        component: () => import(/* webpackChunkName: "ROUTE___EbayPlannerFilterable" */ '@/pages/MarketPlaceTools/EbayPlannerFilterable/EbayPlannerFilterable'),
        meta: {
            securityLevelRequired: ['Administrator', 'Ecommerce Management'],
            title: 'eBay Planner',
            breadcrumbs: [PARENT_MARKETPLACETOOLS, 'eBay']
        }
    },
    {
        path: '/ebay-problem-list',
        name: 'eBayProblemList',
        component: () => import(/* webpackChunkName: "ROUTE___EbayProblemList" */ '@/pages/MarketPlaceTools/EbayProblemList/EbayProblemList'),
        meta: {
            securityLevelRequired: ['Administrator', 'Ecommerce Management'],
            title: 'eBay Problem List',
            breadcrumbs: [PARENT_MARKETPLACETOOLS]
        }
    },
    {
        path: '/back-in-stock',
        name: 'BackInStock',
        component: () => import(/* webpackChunkName: "ROUTE___BackInStock" */ '@/pages/ReportsAndLists/BackInStock/BackInStock'),
        meta: {
            securityLevelRequired: ['Administrator', 'Ecommerce Management'],
            title: 'Back in Stock Report',
            breadcrumbs: [PARENT_REPORTSLISTS]
        }
    },
    {
        path: '/products/ebay/:uid',
        name: 'eBayProduct',
        component: () => import(/* webpackChunkName: "ROUTE___EbayProductEdit" */ '@/pages/ProductManagement/Products/EbayProductActivation/EbayProductActivation'),
        meta: {
            securityLevelRequired: ['Administrator', 'Ecommerce Management'],
            title: 'eBay Item Settings',
            breadcrumbs: [PARENT_PRODUCTMANAGEMENT],
            hideFromNav: true
        }
    },
    {
        path: '/ebay-log',
        name: 'eBayLog',
        component: () => import(/* webpackChunkName: "ROUTE___EbayLog" */ '@/pages/MarketPlaceTools/EbayLog/EbayLog'),
        meta: {
            securityLevelRequired: ['Administrator', 'Ecommerce Management'],
            title: 'eBay Log',
            breadcrumbs: [PARENT_MARKETPLACETOOLS]
        }
    },
    {
        path: '/ebay-templates',
        name: 'eBayTemplates',
        component: () => import(/* webpackChunkName: "ROUTE___EbayTemplates" */ '@/pages/MarketPlaceTools/EbayTemplates/EbayTemplates'),
        meta: {
            securityLevelRequired: ['Administrator', 'Ecommerce Management'],
            title: 'eBay Templates',
            breadcrumbs: [PARENT_MARKETPLACETOOLS, 'eBay']
        }
    },
    {
        path: '/ebay-templates/new',
        name: 'NewEbayTemplate',
        component: () => import(/* webpackChunkName: "ROUTE___EbayTemplatesEdit" */ '@/pages/MarketPlaceTools/EbayTemplates/EbayTemplatesEdit/EbayTemplatesEdit'),
        meta: {
            securityLevelRequired: ['Administrator', 'Ecommerce Management'],
            title: 'New eBay Template',
            breadcrumbs: [PARENT_MARKETPLACETOOLS],
            hideFromNav: true
        }
    },
    {
        path: '/ebay-templates/:uid',
        name: 'eBayTemplateEdit',
        component: () => import(/* webpackChunkName: "ROUTE___EbayTemplatesEdit" */ '@/pages/MarketPlaceTools/EbayTemplates/EbayTemplatesEdit/EbayTemplatesEdit'),
        meta: {
            securityLevelRequired: ['Administrator', 'Ecommerce Management'],
            title: 'eBay Templates Edit',
            breadcrumbs: [PARENT_MARKETPLACETOOLS],
            hideFromNav: true
        }
    },
    {
        path: '/primary-categories',
        name: 'PrimaryCategories',
        component: () => import(/* webpackChunkName: "ROUTE___PrimaryCategories" */ '@/pages/ReportsAndLists/PrimaryCategories/PrimaryCategories'),
        meta: {
            securityLevelRequired: ['Administrator', 'Ecommerce Management'],
            title: 'Primary Categories Report',
            breadcrumbs: [PARENT_REPORTSLISTS]
        }
    },
    {
        path: '/wizards',
        name: 'Wizards',
        component: () => import(/* webpackChunkName: "ROUTE___Wizards" */ '@/pages/Wizards/Wizards'),
        meta: {
            securityLevelRequired: ['Administrator', 'Ecommerce Management'],
            title: 'Bulk Wizards',
            breadcrumbs: [PARENT_WIZARDS]
        }
    },
    {
        path: '/wizards/product/:wizardname',
        name: 'ProductWizard',
        component: () => import(/* webpackChunkName: "ROUTE___ProductWizard" */ '@/pages/Wizards/ProductWizard/ProductWizard'),
        meta: {
            securityLevelRequired: ['Administrator', 'Ecommerce Management'],
            title: 'Item Wizard',
            breadcrumbs: [PARENT_WIZARDS],
            hideFromNav: true
        }
    },
    {
        path: '/wizards/star-buys/:wizardname',
        name: 'StarBuysWizard',
        component: () => import(/* webpackChunkName: "ROUTE___StarBuysWizard" */ '@/pages/Wizards/StarBuysWizard/StarBuysWizard'),
        meta: {
            securityLevelRequired: ['Administrator', 'Ecommerce Management'],
            title: 'Star Buys Wizard',
            breadcrumbs: [PARENT_WIZARDS],
            hideFromNav: true
        }
    },
    {
        path: '/wizards/find-and-filter-collection/:wizardName',
        name: 'FindAndFilterCollectionWizard',
        component: () => import(/* webpackChunkName: "ROUTE___FindAndFilterCollectionWizard" */ '@/pages/Wizards/FindAndFilterCollectionWizard/FindAndFilterCollectionWizard'),
        meta: {
            securityLevelRequired: ['Administrator', 'Ecommerce Management'],
            title: 'Find & Filter Collection Wizard',
            breadcrumbs: [PARENT_WIZARDS],
            hideFromNav: true
        }
    },
    {
        path: '/wizards/ebay-category/:wizardname',
        name: 'EbayCategoryWizard',
        component: () => import(/* webpackChunkName: "ROUTE___EbayCategoryWizard" */ '@/pages/Wizards/EbayCategoryWizard/EbayCategoryWizard'),
        meta: {
            securityLevelRequired: ['Administrator', 'Ecommerce Management'],
            title: 'eBay Category Wizard',
            breadcrumbs: [PARENT_WIZARDS],
            hideFromNav: true
        }
    },
    {
        path: '/super-users',
        name: 'SuperUserHome',
        component: () => import(/* webpackChunkName: "ROUTE___SuperUserHome" */ '@/pages/SuperUsers/SuperUsers'),
        meta: {
            securityLevelRequired: ['Administrator', 'Ecommerce Management'],
            title: 'Super Users',
            hideFromNav: true
        }
    },
    {
        path: '/integrated-payment-processing',
        name: 'IntegratedPaymentProcessing',
        component: () => import(/* webpackChunkName: "ROUTE___IntegratedPaymentProcessing" */ '@/pages/SuperUsers/IntegratedPaymentProcessing/IntegratedPaymentProcessing'),
        meta: {
            securityLevelRequired: ['Administrator'],
            superUsersOnly: true,
            title: 'Integrated Payment Processing',
            breadcrumbs: [PARENT_SUPERUSERS]
        }
    },
    {
        path: '/image-gallery',
        name: 'ImageGallery',
        component: () => import(/* webpackChunkName: "ROUTE___ImageGallery" */ '@/pages/SiteManagement/ImageGallery/ImageGallery'),
        meta: {
            securityLevelRequired: ['Administrator', 'Ecommerce Management'],
            superUsersOnly: false,
            title: 'Image Gallery',
            breadcrumbs: [PARENT_SITEMANAGEMENT]
        }
    },
    {
        path: '/products-advanced',
        name: 'AdvancedItemSearch',
        component: () => import(/* webpackChunkName: "ROUTE___AdvancedProductSearch" */ '@/pages/ProductManagement/AdvancedProductSearch/AdvancedProductSearch'),
        meta: {
            securityLevelRequired: ['Administrator', 'Ecommerce Management'],
            superUsersOnly: false,
            title: 'Advanced Item Search',
            breadcrumbs: [PARENT_PRODUCTMANAGEMENT]
        }
    },
    {
        path: '/size-filter-rules',
        name: 'SizeFilterRules',
        component: () => import(/* webpackChunkName: "ROUTE___SizeFilterRules" */ '@/pages/SuperUsers/SizeFilterRules/SizeFilterRules'),
        meta: {
            securityLevelRequired: ['Administrator'],
            superUsersOnly: true,
            title: 'Size Filter Rules',
            breadcrumbs: [PARENT_SUPERUSERS]
        }
    },
    {
        path: '/size-filter-rules/new',
        name: 'NewSizeFilterRules',
        component: () => import(/* webpackChunkName: "ROUTE___SizeFilterRuleEdit" */ '@/pages/SuperUsers/SizeFilterRules/SizeFilterRulesEdit/SizeFilterRulesEdit'),
        meta: {
            securityLevelRequired: ['Administrator'],
            superUsersOnly: true,
            title: 'New Size Filter Rule',
            breadcrumbs: [PARENT_SUPERUSERS],
            hideFromNav: true
        }
    },
    {
        path: '/size-filter-rules/:uid',
        name: 'SizeFilterRulesEdit',
        component: () => import(/* webpackChunkName: "ROUTE___SizeFilterRuleEdit" */ '@/pages/SuperUsers/SizeFilterRules/SizeFilterRulesEdit/SizeFilterRulesEdit'),
        meta: {
            securityLevelRequired: ['Administrator'],
            superUsersOnly: true,
            title: 'Size Filter Rules Edit',
            breadcrumbs: [PARENT_SUPERUSERS],
            hideFromNav: true
        }
    },
    {
        path: '/payments',
        name: 'Payments',
        component: () => import(/* webpackChunkName: "ROUTE___Payments" */ '@/pages/SiteManagement/Payments/Payments'),
        meta: {
            securityLevelRequired: ['Administrator', 'Payment Management', 'Payments Administrator'],
            superUsersOnly: false,
            title: 'Payments',
            breadcrumbs: [PARENT_SITEMANAGEMENT]
        }
    },
    {
        path: '/payouts',
        name: 'payouts',
        component: () => import(/* webpackChunkName: "ROUTE___Payouts" */ '@/pages/SiteManagement/Payouts/Payouts'),
        meta: {
            securityLevelRequired: ['Administrator', 'Payment Management', 'Payments Administrator'],
            superUsersOnly: false,
            title: 'Payouts',
            breadcrumbs: [PARENT_SITEMANAGEMENT]
        }
    },
    {
        path: '/payouts/detail/:payoutId/:payoutProvider/:createdData/:arrivalDate',
        name: 'payoutsDetail',
        component: () => import(/* webpackChunkName: "ROUTE___PayoutsDetail" */ '@/pages/SiteManagement/Payouts/PayoutsDetail/PayoutsDetail'),
        meta: {
            securityLevelRequired: ['Administrator', 'Payment Management', 'Payments Administrator'],
            superUsersOnly: false,
            title: 'Payouts Detail',
            breadcrumbs: [PARENT_SITEMANAGEMENT],
            hideFromNav: true
        }
    },
    {
        path: '/site-messaging',
        name: 'UserSiteMessagingPage',
        component: () => import(/* webpackChunkName: "ROUTE___UserSiteMessaging" */ '@/pages/SiteManagement/UserSiteMessaging/UserSiteMessaging'),
        meta: {
            securityLevelRequired: ['Administrator', 'Ecommerce Management'],
            superUsersOnly: false,
            title: 'Site Messaging',
            breadcrumbs: [PARENT_SITEMANAGEMENT]
        }
    },
    {
        path: '/amazon-management',
        name: 'AmazonManagement',
        component: () => import(/* webpackChunkName: "ROUTE___AmazonManagement" */ '@/pages/MarketPlaceTools/AmazonManagement/AmazonManagement'),
        props: route => ({
            state: route.query.state,
            /* eslint-disable camelcase */
            mws_auth_token: route.query.mws_auth_token,
            selling_partner_id: route.query.selling_partner_id,
            spapi_oauth_code: route.query.spapi_oauth_code,
            /* eslint-enable camelcase */
            error: route.query.error
        }),
        meta: {
            securityLevelRequired: ['Administrator', 'Ecommerce Management'],
            superUsersOnly: false,
            title: 'Amazon Management',
            breadcrumbs: [PARENT_MARKETPLACETOOLS],
            hideFromNav: false
        }
    },
    {
        path: '/import-values',
        name: 'ImportValues',
        component: () => import(/* webpackChunkName: "ROUTE___ImportValues" */ '@/pages/ReportsAndLists/ImportValues/ImportValues'),
        meta: {
            securityLevelRequired: ['Administrator', 'Ecommerce Management'],
            superUsersOnly: false,
            title: 'Import Values',
            breadcrumbs: [PARENT_REPORTSLISTS],
            hideFromNav: true
        }
    },
    {
        path: '/site-review-options',
        name: 'SiteReviewProviderOptions',
        component: () => import(/* webpackChunkName: "ROUTE___SiteReviewProviderOptions" */ '@/pages/SuperUsers/SiteReviewProviderOptions/SiteReviewProviderOptions'),
        meta: {
            securityLevelRequired: ['Administrator'],
            superUsersOnly: true,
            title: 'Site Review Provider Options',
            breadcrumbs: [PARENT_SUPERUSERS]
        }
    },
    {
        path: '/detailed-coupons-usage',
        name: 'DetailedCouponsUsage',
        component: () => import(/* webpackChunkName: "ROUTE___DetailedCouponsUsage" */ '@/pages/MarketingPromotions/Coupons/DetailedUsage/DetailedCouponUsage'),
        meta: {
            securityLevelRequired: ['Administrator', 'Ecommerce Management'],
            title: 'Detailed Coupon Usage Report',
            breadcrumbs: [PARENT_MARKETINGPROMOTIONS, 'Coupons']
        }
    },
    {
        path: '/kount-credentials',
        name: 'KountCredentials',
        component: () => import(/* webpackChunkName: "ROUTE___KountCredentials" */ '@/pages/SuperUsers/KountCredentials/KountCredentials'),
        meta: {
            securityLevelRequired: ['Administrator'],
            superUsersOnly: true,
            title: 'Kount Site Credentials',
            breadcrumbs: [PARENT_SUPERUSERS]
        }
    },
    {
        path: '/starbuy/faf',
        name: 'FAFStarBuys',
        component: () => import(/* webpackChunkName: "ROUTE___StarBuys" */ '@/pages/MarketingPromotions/StarBuys/FAFStarBuys'),
        meta: {
            securityLevelRequired: ['Administrator', 'Ecommerce Management'],
            title: 'Find & Filter Star Buys',
            breadcrumbs: [PARENT_MARKETINGPROMOTIONS, 'StarBuys']
        }
    },
    {
        path: '/starbuy/item',
        name: 'ItemStarBuys',
        component: () => import(/* webpackChunkName: "ROUTE___StarBuys" */ '@/pages/MarketingPromotions/StarBuys/ItemStarBuys'),
        meta: {
            securityLevelRequired: ['Administrator', 'Ecommerce Management'],
            title: 'Item to Item Star Buys',
            breadcrumbs: [PARENT_MARKETINGPROMOTIONS, 'StarBuys']
        }
    },
    {
        path: '/starbuy/:id',
        name: 'EditStarBuy',
        component: () => import(/* webpackChunkName: "ROUTE___EditStarBuy" */ '@/pages/MarketingPromotions/StarBuys/Edit/EditStarBuy'),
        props: true,
        meta: {
            securityLevelRequired: ['Administrator', 'Ecommerce Management'],
            title: 'Edit Star Buy',
            breadcrumbs: [PARENT_MARKETINGPROMOTIONS],
            hideFromNav: true
        }
    },
    {
        path: '/starbuy',
        name: 'CreateStarBuy',
        component: () => import(/* webpackChunkName: "ROUTE___EditStarBuy" */ '@/pages/MarketingPromotions/StarBuys/Edit/EditStarBuy'),
        props: { id: 0 },
        meta: {
            securityLevelRequired: ['Administrator', 'Ecommerce Management'],
            title: 'New Star Buy',
            breadcrumbs: [PARENT_MARKETINGPROMOTIONS, 'StarBuys'],
            hideFromNav: true
        }
    },
    {
        path: '/link-collections',
        name: 'LinkCollections',
        component: () => import(/* webpackChunkName: "ROUTE___LinkCollections" */ '@/pages/SiteManagement/LinkCollections/LinkCollections'),
        meta: {
            securityLevelRequired: ['Administrator', 'Ecommerce Management'],
            superUsersOnly: false,
            title: 'Link Collections',
            breadcrumbs: [PARENT_SITEMANAGEMENT]
        }
    },
    {
        path: '/link-collections/:uid',
        name: 'LinkCollectionsEdit',
        component: () => import(/* webpackChunkName: "ROUTE___LinkCollectionsEdit" */ '@/pages/SiteManagement/LinkCollections/LinkCollectionEdit/LinkCollectionEdit'),
        meta: {
            securityLevelRequired: ['Administrator', 'Ecommerce Management'],
            superUsersOnly: false,
            title: 'Link Collections Edit',
            breadcrumbs: [PARENT_SITEMANAGEMENT],
            hideFromNav: true
        }
    },
    {
        path: '/link-collections/entry/:uid',
        name: 'LinkCollectionsEntryEdit',
        component: () => import(/* webpackChunkName: "ROUTE___LinkCollectionsEntryEdit" */ '@/pages/SiteManagement/LinkCollections/LinkCollectionEntriesEdit/LinkCollectionEntriesEdit'),
        meta: {
            securityLevelRequired: ['Administrator', 'Ecommerce Management'],
            superUsersOnly: false,
            title: 'Link Collections Entry Edit',
            breadcrumbs: [PARENT_SITEMANAGEMENT],
            hideFromNav: true
        }
    },
    {
        path: '/websim-licences',
        name: 'WebSimLicences',
        component: () => import(/* webpackChunkName: "ROUTE___WebSimLicences" */ '@/pages/SuperUsers/WebSimLicences/WebSimLicences'),
        meta: {
            securityLevelRequired: ['Administrator'],
            superUsersOnly: true,
            title: 'WebSIM Licences',
            breadcrumbs: [PARENT_SUPERUSERS, 'WebSimLicence']
        }
    },
    {
        path: '/websim-licence/:id',
        name: 'WebSimLicenceEdit',
        component: () => import(/* webpackChunkName: "ROUTE___WebSimLicenceEdit" */ '@/pages/SuperUsers/WebSimLicences/WebSimLicenceEdit/WebSimLicenceEdit'),
        props: true,
        meta: {
            securityLevelRequired: ['Administrator'],
            superUsersOnly: true,
            title: 'WebSIM Licence Edit',
            breadcrumbs: [PARENT_SUPERUSERS],
            hideFromNav: true
        }
    },
    {
        path: '/websim-licence',
        name: 'WebSimLicenceCreate',
        component: () => import(/* webpackChunkName: "ROUTE___WebSimLicenceEdit" */ '@/pages/SuperUsers/WebSimLicences/WebSimLicenceEdit/WebSimLicenceEdit'),
        props: { id: 0 },
        meta: {
            securityLevelRequired: ['Administrator'],
            superUsersOnly: true,
            title: 'New WebSIM Licence',
            breadcrumbs: [PARENT_SUPERUSERS, 'WebSimLicence'],
            hideFromNav: true
        }
    },
    {
        path: '/cl-site-data-options',
        name: 'SiteDataOptionsCitrusLime',
        component: () => import(/* webpackChunkName: "ROUTE___SiteDataOptionsCitrusLime" */ '@/pages/SuperUsers/SiteDataOptions/SiteDataOptions'),
        meta: {
            securityLevelRequired: ['Administrator'],
            superUsersOnly: true,
            title: 'Site Data Options (Citrus-Lime)',
            breadcrumbs: [PARENT_SUPERUSERS]
        }
    },
    {
        path: '/paypal-config',
        name: 'PayPalConfig',
        component: () => import(/* webpackChunkName: "ROUTE___PayPalConfig" */ '@/pages/SiteManagement/PayPalConfig/PayPalConfig'),
        props: route => ({
            merchantIdInPayPal: route.query.merchantIdInPayPal ?? null,
            permissionsGranted: route.query.permissionsGranted ?? true,
            consentStatus: route.query.consentStatus ?? true,
            preventNotAuthorisedHandling: route.query.preventNotAuthorisedHandling ?? false
        }),
        meta: {
            securityLevelRequired: ['Administrator'],
            title: 'PayPal Configuration',
            breadcrumbs: [PARENT_SITEMANAGEMENT]
        }
    },
    {
        path: '/paypal-options',
        name: 'PayPalOptions',
        component: () => import(/* webpackChunkName: "ROUTE___PayPalOptions" */ '@/pages/SuperUsers/PayPalOptions/PayPalOptions'),
        meta: {
            securityLevelRequired: ['Administrator'],
            superUsersOnly: true,
            title: 'PayPal Options',
            breadcrumbs: [PARENT_SUPERUSERS]
        }
    },
    {
        path: '/veeqo-config',
        name: 'VeeqoConfig',
        component: () => import(/* webpackChunkName: "ROUTE___VeeqoConfig" */ '@/pages/SiteManagement/VeeqoConfig/VeeqoConfig'),
        props: route => ({
            code: route.query.code ?? null
        }),
        meta: {
            securityLevelRequired: ['Administrator'],
            title: 'Veeqo Configuration',
            breadcrumbs: [PARENT_SITEMANAGEMENT]
        }
    },
    {
        path: '/fatal',
        name: 'FatalError',
        component: () => import(/* webpackChunkName: "ROUTE___FatalError" */ '@/pages/Errors/Fatal/error-Fatal'),
        meta: {
            securityLevelRequired: ['Administrator', 'Ecommerce Management', 'Payment Management', 'Payments Administrator'],
            title: 'Application Error'
        }
    },
    /*
     * This record must be last in the list of routes, it's a catch-all 404 page.
     */
    {
        path: '*',
        name: '404',
        component: () => import(/* webpackChunkName: "ROUTE___Error404" */ '@/pages/Errors/404/error-404'),
        meta: {
            securityLevelRequired: ['Administrator', 'Ecommerce Management', 'Payment Management', 'Payments Administrator'],
            title: 'Error 404'
        }
    }
];

function buildRoutes() {
    ROUTES.forEach((route) => {
        let firstRouteFragment = (route.path ?
            route.path.split('/') :
            '');

        if (firstRouteFragment && firstRouteFragment.length > 1) {
            firstRouteFragment = firstRouteFragment.slice(1)[0];
        }

        let foundSimilar = [];

        if (route.path !== '/') {
            const MATCHING_NAME = ROUTES.filter(e => e.path.startsWith(`/${firstRouteFragment}`) &&
                e.path !== route.path &&
                e.path.indexOf(':') == -1);
            let matchingBreadcrumbs = [];

            if (route.meta.breadcrumbs) {
                const BREADCRUMBS = route.meta.breadcrumbs.slice(1);

                matchingBreadcrumbs = ROUTES.filter(r => BREADCRUMBS.some(b => r.meta.breadcrumbs ? r.meta.breadcrumbs.includes(b) : false));
            }

            foundSimilar = [...matchingBreadcrumbs, ...MATCHING_NAME]
                .filter((similarRoute, i, self) => i == self.findIndex(s => s.name == similarRoute.name))
                .filter(similarRoute => similarRoute.name != route.name);
        }

        route.meta.similar = foundSimilar.map(e => {
            return {
                text: e.meta.title,
                link: e.path,
                requiresB2C: e.meta.requiresB2C
            };
        });
    });

    return ROUTES;
}

export function superUserPages() {
    return ROUTES.filter(route => (route.meta.breadcrumbs && route.meta.breadcrumbs.includes(PARENT_SUPERUSERS)));
}

export function buildNavigation() {
    const NAVIGATION_STRUCTURE = [];
    const user = auth.userinfo();

    ROUTES.forEach(route => {
        if (route.meta.breadcrumbs && !route.meta.hideFromNav && route.meta.securityLevelRequired.some(s => s === user.userinfo.securityLevelName)) {
            if (!NAVIGATION_STRUCTURE.some(arr => arr.text === route.meta.breadcrumbs[0])) {
                NAVIGATION_STRUCTURE.push({
                    text: route.meta.breadcrumbs[0],
                    active: true,
                    sublinks: []
                });
            }

            const INDEX_TO_ADD = NAVIGATION_STRUCTURE.findIndex(arr => arr.text === route.meta.breadcrumbs[0]);

            NAVIGATION_STRUCTURE[INDEX_TO_ADD].sublinks.push({
                text: route.meta.title,
                url: route.path,
                super: (route.meta.superUsersOnly ?
                    route.meta.superUsersOnly :
                    false)
            });
        }
    });

    NAVIGATION_STRUCTURE.forEach(menuitem => {
        menuitem.sublinks.sort((a, b) => a.text.toUpperCase() > b.text.toUpperCase() ?
            1 :
            -1);
    });

    return NAVIGATION_STRUCTURE.sort((a, b) => a.text.toUpperCase() > b.text.toUpperCase() ?
        1 :
        -1);
}

export default buildRoutes;
